module.exports = __webpack_public_path__ + "img/image-in-progress.e45aa31e.svg";